import flatten from 'lodash/flatten';

import type { OptionItem } from '@app/src/app/shared/components/form/components/form-grouped-select/form-grouped-select.types';
import { UserListCategory } from '@app/src/app/shared/components/user-list-filter';

import { getIcon } from '../constants/icon-mapper';
import {
  type ActionGroup,
  type ActionItem,
  AssignmentType,
  FlexAssignmentType,
  PastAssignment,
  type Student,
} from '../types/tt-my-class.types';

export const countSort = (a: ActionItem, b: ActionItem) => b.count - a.count;

const actionItemMapper = assignType => p => ({
  data: p,
  value: p.id,
  label: p.name,
  count: p.count,
  assignmentType: assignType,
  ...getIcon(assignType, p),
});

export const hallPassMapper = actionItemMapper(AssignmentType.HALLPASS);
export const behaviorMapper = actionItemMapper(AssignmentType.BEHAVIOR);
export const consequenceMapper = actionItemMapper(AssignmentType.CONSEQUENCE);
export const checkInMapper = actionItemMapper(AssignmentType.CHECK_IN);

export const mapActionGroupsToItems = (actionGroups: ActionGroup[]): ActionItem[] => {
  const actions = (actionGroups || []).map(g => {
    const { items, ...category } = g;

    return items.map(item => ({
      ...item,
      category,
    }));
  });

  return flatten(actions);
};

export const groupAndCount = (types: PastAssignment[]) => {
  const grouped = types.reduce((acc, item) => {
    const id = item.value;

    if (!acc[id]) {
      acc[id] = {
        items: [],
        count: 0,
      };
    }

    acc[id].items.push(item);
    acc[id].count++;

    return acc;
  }, {});

  return Object.values(grouped).map((value: { count: number; items: PastAssignment[] }) => {
    const { items, count } = value;

    return {
      ...items[0],
      count,
    };
  });
};

export const mapPersonToStudent = (p): Student => ({
  firstName: p.firstName,
  lastName: p.lastName,
  profileImageUrl: p.profileImageUrl,
  personHash: p.personHash || p.hash,
  studentId: p.studentId,
  filename: p.filename,
  flexTimeActivity: p.flexTimeActivity,
  listTypeOrigin: p.listTypeOrigin,
});

export const isFlexCheckInAction = (action: ActionItem | null): boolean => {
  return action?.assignmentType === AssignmentType.FLEX_TIME && action?.value === FlexAssignmentType.CHECKIN;
};

export const canDoFlexCheckIn = (lists: OptionItem<number, any>[]): boolean => {
  // we must have 1 lists selected
  if (lists?.length !== 1) return false;

  const list = lists[0];

  const SUPPORTS_FLEX_CHECK_IN = [
    UserListCategory.TODAYS_FLEX_ACTIVITIES,
    UserListCategory.TODAYS_FLEX_ACTIVITIES_MINE,
  ];
  return SUPPORTS_FLEX_CHECK_IN.includes(list?.category?.value);
};
